import React from "react";
import { Transition } from "@headlessui/react";
const Modal = props => (
  <div className="flex flex-col mx-auto align-bottom bg-white rounded-lg  text-left overflow-hidden  transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-2">
    {props.children}
  </div>
);

export default Modal;
